import { render, staticRenderFns } from "./AddCheckList.vue?vue&type=template&id=22477880&"
import script from "./AddCheckList.vue?vue&type=script&lang=js&"
export * from "./AddCheckList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports